const Black = {
  level4: '#000000',
  level1: '#D1D1D1',
};

export { Black };
